<template>
	<div class="ReList">
		<!--span> taskCounter {{taskCounter}}</!--span-->
		<template v-if="!$GVO.isEmpty(masTasks)">
			<div class="titleBlk">
				<div class="col-2 timeHeader"><h4 class="d-inline-block">ВРЕМЯ</h4></div>
				<div class="col-4 pl-1 pr-0 taskHeader"><h4 class="d-inline-block">ЗАДАЧА</h4></div>
				<div class="col-2 clientHeader"><h4 class="d-inline-block">КЛИЕНТ</h4></div>
				<div class="col-2 agentHeader"><h4 class="d-inline-block">ОТВЕТСТВЕННЫЙ ЗА УСЛУГУ</h4></div>
				<div class="col-2 agentHeader"><h4 class="d-inline-block">ОТВЕТСТВЕННЫЙ ЗА ЗАДАЧУ</h4></div>
			</div>

			<collapse v-if="!$GVO.isEmpty(masTasks)" activeIndexType="all">
				<template v-for="(taskGr,dtKey) in masTasks">
					<collapse-item :title="formatDateTitle(dtKey)" :name="'ci_'+dtKey" :key="dtKey">						
						<template v-if="!$GVO.isEmpty(masTasks)">
							<div class="taskBlock-container" v-for="task in taskGr" :key="task.id">
								<ReListItem :task="task"  />
							</div>
						</template>
					</collapse-item>
				</template>
			</collapse>

			<button v-if="bShowList" class="btn btn-simple btn-success w-100 mt-3" @click="LoadMore('list')">Загрузить ещё</button>
		</template>
		<template v-else>
			<h3>Задач не найдено</h3>
		</template>
	</div>
</template>

<script>
import moment from 'moment';
import VueMoment from 'vue-moment';
import { Collapse, CollapseItem } from 'src/components';
import ReListItem from 'src/our_components/TasksView/ReListItem.vue';
moment.locale('ru');

	export default {
		name: 'ReList',
		components: {
			Collapse,
			CollapseItem,
			ReListItem,
		},
		props: {
			masTasks: Object,
			bShowList:{
				type: Boolean,
				default: true
			},			
		},
		data () {
			return {
				ver: 1,
				taskCounter: 0,
				
			}
		},
		computed: {

		},
		methods: {
			/*
			client_id(){
				if(typeof this.task.client_id != 'undefined'){
					return this.task.client_id;
				}
				return this.task.client_id;
			},*/
			// OpenCard: function(client_id){
			// 	this.$router.push({path: '/data/clients/id/'+client_id});
			// },					
			formatDateTitle(strDt){
				return moment(strDt).format('D MMMM YYYY dddd');  
			},
			LoadMore(strType){
				this.$emit('loadmore', strType);
			},			
				
		},
		created() {
		
		}
	}
</script>
<style scoped>

.dateBlock, .taskBlock, .titleBlk {
	display: flex;
	width: 100%;
	padding: 7px 10px 7px 0;
	align-items: center;
}   
.dateBlock {
	background-color: #01B0E0;
}
.taskBlock {
	min-height: 50px;
}
.taskBlock-container {
	border-bottom: 1px solid #5C70A4;
}
.titleBlk h4 {margin-bottom: 10px;}


.ReList >>> .card-body {padding: 0;}
.ReList >>> .card-collapse .card:not(.card-cinc) .card-body {padding-left: 0; padding-right: 0;}
.ReList >>> .card-collapse .card:not(.card-cinc) .card-header a {color: #01B0E0 ;}

@media (max-width: 900px) {
	.clientHeader, .agentHeader, .clientBlk, .agentBlk {
		display: none;
	}
}
/*
@media (max-width: 400px) {
	.taskName p, .taskBlock p {max-width: 225px;}
}*/


</style>
